import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Safely joins URL parts, removing duplicate slashes except after protocol
export function joinUrl(...parts: string[]): string {
  return parts
    .filter(Boolean)
    .join('/')
    .replace(/([^:]\/)\/+/g, '$1') // Remove duplicate slashes except after protocol
    .replace(/\/$/, ''); // Remove trailing slash
}
